"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARKET_ORDER_SUPPORT_DESC = void 0;
const ExchangeID_1 = require("../ExchangeAPI/ExchangeID");
const TradeTypeDef_1 = require("../ExchangeAPIAdapter/TradeTypeDef");
/**
 * 交易支持的市场描述
 */
exports.MARKET_ORDER_SUPPORT_DESC = {
    [ExchangeID_1.ExchangeID.BINANCE]: {
        webSocket: {
            supportTicker: true,
            supportDepth: true,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: false,
            displayWeight: 90,
        },
        isV2: false,
        useCloud: true,
        aiShocks: true,
        localLogic: false,
        futureTag: ".SWAP",
        supportStopLoss: true,
        support: [TradeTypeDef_1.ExchangeOrderType.limit, TradeTypeDef_1.ExchangeOrderType.market, TradeTypeDef_1.ExchangeOrderType.grid, TradeTypeDef_1.ExchangeOrderType.gridFuture,
            TradeTypeDef_1.ExchangeOrderType.stopLimit, TradeTypeDef_1.ExchangeOrderType.trailingStop],
    },
    [ExchangeID_1.ExchangeID.BITBNS]: {
        webSocket: {
            supportTicker: true,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 40,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: false,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.GRID],
    },
    [ExchangeID_1.ExchangeID.BITFINEX]: {
        webSocket: {
            supportTicker: true,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 85,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        isV2: true,
        supportStopLoss: false,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.MARKET, TradeTypeDef_1.OrderTypeDesc.GRID_PRO],
    },
    [ExchangeID_1.ExchangeID.BITGET]: {
        webSocket: {
            supportTicker: true,
            supportDepth: true,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: false,
            useCloud: true,
            displayWeight: 0,
        },
        isV2: true,
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: false,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.GRID_FUTURE],
    },
    [ExchangeID_1.ExchangeID.BIGONE]: {
        webSocket: {
            supportTicker: true,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 20,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: false,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.MARKET, TradeTypeDef_1.OrderTypeDesc.GRID],
    },
    [ExchangeID_1.ExchangeID.BITHUMB]: {
        webSocket: {
            supportTicker: true,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 0,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: true,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.GRID],
    },
    [ExchangeID_1.ExchangeID.BITOPRO]: {
        webSocket: {
            supportTicker: false,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 0,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: true,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.MARKET, TradeTypeDef_1.OrderTypeDesc.GRID],
    },
    [ExchangeID_1.ExchangeID.BITTREX]: {
        webSocket: {
            supportTicker: false,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: false,
            displayWeight: 0,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: true,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.STOP_LIMIT, TradeTypeDef_1.OrderTypeDesc.GRID],
    },
    [ExchangeID_1.ExchangeID.BYBIT]: {
        webSocket: {
            supportTicker: false,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 80,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: false,
        importCheckTradePermission: false,
        futureTag: ".SWAP",
        support: [TradeTypeDef_1.OrderTypeDesc.GRID_FUTURE],
    },
    [ExchangeID_1.ExchangeID.CEO]: {
        webSocket: {
            supportTicker: true,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 0,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: false,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.MARKET, TradeTypeDef_1.OrderTypeDesc.GRID],
    },
    [ExchangeID_1.ExchangeID.FOBLGATE]: {
        webSocket: {
            supportTicker: true,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 85,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        isV2: true,
        supportStopLoss: false,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.GRID_PRO],
    },
    [ExchangeID_1.ExchangeID.FTX]: {
        webSocket: {
            supportTicker: true,
            supportDepth: true,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 0,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        futureTag: ".SWAP",
        supportStopLoss: false,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.GRID, TradeTypeDef_1.OrderTypeDesc.GRID_FUTURE],
    },
    [ExchangeID_1.ExchangeID.GATE_IO]: {
        webSocket: {
            supportTicker: true,
            supportDepth: true,
            supportOrder: false,
            supportTrades: false,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 0,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.GRID],
    },
    [ExchangeID_1.ExchangeID.HBTC]: {
        webSocket: {
            supportTicker: true,
            supportDepth: true,
            supportOrder: true,
            supportTrades: false,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 70,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: true,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.GRID, TradeTypeDef_1.OrderTypeDesc.MARKET],
    },
    [ExchangeID_1.ExchangeID.HYDAX]: {
        webSocket: {
            supportTicker: true,
            supportDepth: true,
            supportOrder: true,
            supportTrades: false,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 60,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: true,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.GRID],
    },
    [ExchangeID_1.ExchangeID.HUOBI]: {
        webSocket: {
            supportTicker: true,
            supportDepth: true,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: false,
            displayWeight: 0,
        },
        useCloud: true,
        aiShocks: true,
        localLogic: false,
        supportStopLoss: true,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.MARKET, TradeTypeDef_1.OrderTypeDesc.STOP_LIMIT, TradeTypeDef_1.OrderTypeDesc.GRID, TradeTypeDef_1.OrderTypeDesc.TRAILING_STOP_LIMIT],
    },
    [ExchangeID_1.ExchangeID.LBANK]: {
        webSocket: {
            supportTicker: false,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 0,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: false,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.GRID],
    },
    [ExchangeID_1.ExchangeID.LIQUID]: {
        webSocket: {
            supportTicker: false,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 0,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: true,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.GRID],
    },
    [ExchangeID_1.ExchangeID.MXC]: {
        webSocket: {
            supportTicker: false,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 50,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: false,
        futureTag: ".SWAP",
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.ExchangeOrderType.limit, TradeTypeDef_1.ExchangeOrderType.grid],
    },
    [ExchangeID_1.ExchangeID.INDODAX]: {
        webSocket: {
            supportTicker: false,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 0,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: false,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.GRID],
    },
    [ExchangeID_1.ExchangeID.KUCOIN]: {
        webSocket: {
            supportTicker: false,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: false,
            displayWeight: 0,
        },
        isV2: true,
        useCloud: true,
        aiShocks: true,
        localLogic: false,
        supportStopLoss: true,
        support: [TradeTypeDef_1.ExchangeOrderType.limit, TradeTypeDef_1.ExchangeOrderType.market, TradeTypeDef_1.ExchangeOrderType.gridV3],
    },
    [ExchangeID_1.ExchangeID.OKEX]: {
        webSocket: {
            supportTicker: true,
            supportDepth: true,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 0,
        },
        isV2: true,
        useCloud: true,
        aiShocks: true,
        localLogic: false,
        supportStopLoss: true,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.ExchangeOrderType.limit, TradeTypeDef_1.ExchangeOrderType.market, TradeTypeDef_1.ExchangeOrderType.gridV3],
    },
    [ExchangeID_1.ExchangeID.COINBASEPRO]: {
        webSocket: {
            supportTicker: true,
            supportDepth: true,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 0,
        },
        isV2: true,
        useCloud: true,
        aiShocks: true,
        localLogic: false,
        supportStopLoss: false,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.ExchangeOrderType.limit, TradeTypeDef_1.ExchangeOrderType.market, TradeTypeDef_1.ExchangeOrderType.gridV3],
    },
    [ExchangeID_1.ExchangeID.PIONEXV2]: {
        webSocket: {
            supportTicker: false,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: true,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 100,
        },
        isV2: true,
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: true,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.ExchangeOrderType.limit, TradeTypeDef_1.ExchangeOrderType.market, TradeTypeDef_1.ExchangeOrderType.gridV3, TradeTypeDef_1.ExchangeOrderType.gridPro, TradeTypeDef_1.ExchangeOrderType.gridShort,
            TradeTypeDef_1.ExchangeOrderType.gridLeverage, TradeTypeDef_1.ExchangeOrderType.gridLoan, TradeTypeDef_1.ExchangeOrderType.ig, TradeTypeDef_1.ExchangeOrderType.twap,
            TradeTypeDef_1.ExchangeOrderType.aip, TradeTypeDef_1.ExchangeOrderType.gridLeverageShort, TradeTypeDef_1.ExchangeOrderType.fsa,
            TradeTypeDef_1.ExchangeOrderType.SR, TradeTypeDef_1.ExchangeOrderType.smartTrade, TradeTypeDef_1.ExchangeOrderType.trailingSell, TradeTypeDef_1.ExchangeOrderType.trailingBuy,
        ],
    },
    [ExchangeID_1.ExchangeID.PIONEX_SWAP]: {
        webSocket: {
            supportTicker: false,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: true,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 100,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: true,
        isV2: true,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.ExchangeOrderType.limit, TradeTypeDef_1.ExchangeOrderType.market],
    },
    [ExchangeID_1.ExchangeID.POLONIEX]: {
        webSocket: {
            supportTicker: true,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: false,
            displayWeight: 0,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: true,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.MARKET, TradeTypeDef_1.OrderTypeDesc.GRID],
    },
    [ExchangeID_1.ExchangeID.PROBIT]: {
        webSocket: {
            supportTicker: true,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 0,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: true,
        importCheckTradePermission: false,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.MARKET, TradeTypeDef_1.OrderTypeDesc.GRID],
    },
    [ExchangeID_1.ExchangeID.SHUBAO]: {
        webSocket: {
            supportTicker: true,
            supportDepth: false,
            supportOrder: false,
            supportTrades: true,
            supportOrderBook: true,
        },
        feeRate: {
            autoCalc: false,
        },
        portfolio: {
            support: true,
            useCloud: true,
            displayWeight: 0,
        },
        useCloud: true,
        aiShocks: false,
        localLogic: false,
        supportStopLoss: true,
        support: [TradeTypeDef_1.OrderTypeDesc.LIMIT, TradeTypeDef_1.OrderTypeDesc.MARKET, TradeTypeDef_1.OrderTypeDesc.GRID],
    },
};
